import styled from 'styled-components'

const SpriteBase = styled.div`
    background: url('/static/images/sprite.svg');
    background-repeat: no-repeat;
`

export const RedArrow = styled(SpriteBase)`
    background-position: -77px -10px;
    width: 35px;
	height: 31px;
`

export const Logo = styled(SpriteBase)`
    background-position: -1px -48px;
    width: 76px;
	height: 190px;
`

export const RightArrow = styled(SpriteBase)`
    background: url('/static/images/sprite.svg') no-repeat -85px -55px;
	width: 23px;
	height: 20px;
`

export const LeftArrow = styled(RightArrow)`
    transform: rotate(180deg);
    margin-right: 10px;
`

export const ThumbnailsIcon = styled(SpriteBase)`
    background-position: -127px -74px;
    width: 21px;
    height: 14px;
    cursor: pointer;
`

export const CarouselNext = styled(SpriteBase)`
    background-position: -125px -2px;
    width: 26px;
    height: 44px;
    margin-left: 20px;
    cursor: pointer;
`

export const CarouselPrev = styled(CarouselNext)`
    transform: rotate(180deg);
    margin-left: 0;
    margin-right: 20px;
`